import { useEvent } from '../../../../hooks/useEvent';
import { useAllowHousingStock } from '../../shared/hooks/allowHousingStock';

export const useToHousingStockFn = ({ linksCreator }) => {
  const allowHousingStock = useAllowHousingStock();

  const useHook = allowHousingStock ? useHousingStockFn : useUndefinedFn;

  return useHook({ linksCreator });
};

function useHousingStockFn({ linksCreator }) {
  return useEvent((location) => {
    const { pathname, from } = linksCreator(location);
    return { pathname, state: { from } };
  });
}

function useUndefinedFn() {
  return undefined;
}
